<template>
    <v-row>
        <v-col>
            <v-checkbox v-model="initialNull" label="Add blank option" @change="emit"/>
            <span class="body-2 text--secondary">If enabled, adds a blank option to the start of the list - used to make the dropdown clearable.</span>
        </v-col>
        <v-col>
            <v-checkbox v-model="selectSingle" label="Select single option" @change="emit"/>
            <span class="body-2 text--secondary">If enabled and there is only one option, selects that one option.</span>
        </v-col>
            <v-col>
                <v-select :items="[{text: 'none'}, {text: 'Ascending', value: 'asc'}, {text: 'Descending', value: 'desc'}]" v-model="sortDirection" label="Sort Direction" @change="emit"/>
                <span class="body-2 text--secondary">How to sort the items. Default is Ascending.</span>
            </v-col>                     
    </v-row>
</template>

<script>
    export default {
        name: 'Dropdown',
        data: () => ({
            initialNull: false,
            selectSingle: false,
            sortDirection: 'none'
        }),
        methods: {
            emit() {
                let opts = {type: 'dropdownlist', initialNullValue: this.initialNull};
                opts.autoSelectSingleValue = this.selectSingle;

                if (this.sortDirection != 'none') {
                    opts.sortOptions = {direction: this.sortDirection};
                }

                this.$emit('change', opts);
            }
        },
        created() {
            this.emit();
        }
    }
</script>
